export default function (other) {
  other = other || {}
  return {
    company: other.company || null,
    leads: other.leads || null,
    ftds: other.ftds || null,
    conversionRate: other.conversionRate || null,
    countries: other.countries || null,
    ftdAmount: other.ftdAmount || null,
    netDeposits: other.netDeposits || null,


  }
}
